export { default as UniversityHeader } from "./universityheader/UniversityHeader";
export { default as UniversityHeaderEdit } from "./universityheader/UniversityHeaderEdit";
export { default as UniversityHero } from "./universityhero/UniversityHero";
export { default as UniversityHeroEdit } from "./universityhero/UniversityHeroEdit";
export { default as UniversityAbout } from "./universityabout/UniversityAbout";
export { default as UniversityAboutEdit } from "./universityabout/UniversityAboutEdit";
export { default as FAQUniversity } from "./universityfaq/FAQUniversity";
export { default as FAQUniversityEdit } from "./universityfaq/FAQUniversityEdit";
export { default as UniversityPrograms } from "./universityprograms/UniversityPrograms";
export { default as UniversityProgramsEdit } from "./universityprograms/UniversityProgramsEdit";
export { default as UniversityCampus } from "./universitycampus/UniversityCampus";
export { default as UniversityCampusEdit } from "./universitycampus/UniversityCampusEdit";
export { default as UniversityResearch } from "./universityresearch/UniversityResearch";
export { default as UniversityResearchEdit } from "./universityresearch/UniversityResearchEdit";
export { default as UniversityEvents } from "./universityevents/UniversityEvents";
export { default as UniversityEventsEdit } from "./universityevents/UniversityEventsEdit";
export { default as UniversityBlog } from "./universityblog/UniversityBlog";
export { default as UniversityBlogEdit } from "./universityblog/UniversityBlogEdit";
export { UniversityFooter } from "./universityfooter/UniversityFooter";
export { default as UniversityFooterEdit } from "./universityfooter/UniversityFooterEdit";
